import './change-password-form.styles.scss';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { checkResetPasswordCode, changePassword } from '../../service/authentication.service';
import RoundedBox from '../rounded-box/rounded-box.component';
import FormField from '../form-field/form-field.component';
import Loader from '../loader/loader.component';

const defaultFormFields = {
    password: '',
    passwordConfirmation: ''
};

const defaultErrors = {
    password: '',
    passwordConfirmation: ''
};

const ChangePasswordForm = () => {
    const [searchParams] = useSearchParams();

    const [formFields, setFormFields] = useState(defaultFormFields);
    const [errors, setErrors] = useState(defaultErrors);
    const [isLoading, setIsLoading] = useState(true);
    const [isVerificationCodeValid, setIsVerificationCodeValid] = useState(true);
    const [displayFeedback, setDisplayFeedback] = useState(false);
    
    const verificationCode = searchParams.get('oobCode');
    const { password, passwordConfirmation } = formFields;

    useEffect(() => {
        checkResetPasswordCode(verificationCode)
            .catch(() => setIsVerificationCodeValid(false))
            .finally(() => setIsLoading(false));
    }, [])

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormFields({ ...formFields, [name]: value});
    };

    const isFormValid = () => {
        let isValid = true;
        let newErrors = defaultErrors;

        if (password != passwordConfirmation) {
            newErrors = {
                ...newErrors,
                password: "Senhas devem ser iguais",
                passwordConfirmation: "Senhas devem ser iguais"
            };
            
            isValid = false;
        }

        if (password.length < 6) {
            newErrors = {
                ...newErrors,
                password: "Senha: mínimo 6 caracteres"
            };
            
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (isFormValid()) {
            setIsLoading(true);
            changePassword(verificationCode, formFields.password)
                .then(() => setDisplayFeedback(true))
                .catch(() => 
                    setErrors({
                        ...defaultErrors,
                        passwordConfirmation: 'Erro inesperado. Entre em contato com o administrador'
                    }))
                .finally(setIsLoading(false));
        }
    };

    const getErrorMessage = (fieldName) => {
        return !!errors ? errors[fieldName] : null;
    };

    return (
        <div>
            {
                isLoading ? (
                    <Loader/>
                ) : (
                    <RoundedBox className='change-password-form-container'>
                        {
                            displayFeedback ? (
                                <label className='title'>Senha alterada com sucesso!</label>
                            ) : isVerificationCodeValid ? (
                                <form className='change-password-form' onSubmit={handleSubmit}>
                                    <label className='title'>Digite sua nova senha:</label>
                                    <FormField
                                        darkBackground
                                        label='Senha'
                                        name='password'
                                        type='password'
                                        required
                                        value={password}
                                        onChange={handleChange}
                                        errorMessage={getErrorMessage('password')}/>
                                    <FormField
                                        darkBackground
                                        label='Confirmar senha'
                                        name='passwordConfirmation'
                                        type='password'
                                        required
                                        value={passwordConfirmation}
                                        onChange={handleChange}
                                        errorMessage={getErrorMessage('passwordConfirmation')}/>
                                    <div className='footer'>
                                        <Button type='submit' className='send button' variant='contained' size='small'>Enviar</Button>
                                    </div>
                                </form>
                            ) : (
                                <label className='title'>Link para troca de senha expirado ou inválido!</label>
                            )
                        }
                    </RoundedBox>
                )
            }
        </div>
    )
}

export default ChangePasswordForm;